export default __webpack_public_path__ + "static/media/logo-light.d1f4c1bb.svg";